export const DISMISS_ANSWER_FROM_PROCESS_STATEMENT_REQUEST = 'DISMISS_ANSWER_FROM_PROCESS_STATEMENT_REQUEST';

export const dismissAnswerFromProcessStatementRequest = ( id, {
    sendMail,
    deleteAnswer,
    reason,
    toAnswerDate,
    toReminderDate,
    toSubsequentDeliveryDate,
}) => ({
    type: DISMISS_ANSWER_FROM_PROCESS_STATEMENT_REQUEST,
    payload: {
        id,
        sendMail,
        deleteAnswer,
        reason,
        toAnswerDate,
        toReminderDate,
        toSubsequentDeliveryDate,
    }
});
